export const ONBOARDING_STEPS = {
  SIGNUP: 'signup',
  DEALERSHIP_DETAILS: 'dealership_details',
  PLAN_TERMS: 'plan_terms',
  BILLING: 'billing',
  FINISH: 'finish_setup'
};

export const STEP_CONFIG = [
  {
    key: ONBOARDING_STEPS.SIGNUP,
    title: 'Create Your Account',
    description: 'Set up your Hooptie login',
    order: 1
  },
  {
    key: ONBOARDING_STEPS.DEALERSHIP_DETAILS,
    title: 'Dealership Profile',
    description: 'Tell us about your dealership',
    order: 2
  },
  {
    key: ONBOARDING_STEPS.PLAN_TERMS,
    title: 'Plan & Terms',
    description: 'Choose your plan and review terms',
    order: 3
  },
  {
    key: ONBOARDING_STEPS.BILLING,
    title: 'Billing',
    description: 'Add payment method',
    order: 4
  },
  {
    key: ONBOARDING_STEPS.FINISH,
    title: 'Finish Setup',
    description: "You're ready to use Hooptie",
    order: 5
  }
];

export const PLAN_DETAILS = {
  price: 249,
  currency: 'USD',
  period: 'month',
  features: [
    'AI-Powered Market Dashboard',
    'Unlimited VIN Lookups',
    'Active + Sold Comps & Pricing Trends',
    'AI Recommendations for Each Vehicle',
    'Dealer Insights: Market Ranking & Performance',
    '2 Free CarFax Reports Monthly'
  ]
};
